var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('div',{staticClass:"loader"},[_c('md-progress-spinner',{staticClass:"spinner",attrs:{"md-mode":"indeterminate","md-diameter":80,"md-stroke":8}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }